import { acquireGraphAccessTokenSilent } from '@/lib/session-auth';

const GRAPH_PHOTO_ENDPOINT = 'https://graph.microsoft.com/v1.0/me/photo/$value';
const GRAPH_USER_READ_SCOPE = ['User.Read'];

type PhotoState =
  | { readonly status: 'pending'; readonly promise: Promise<string | null> }
  | { readonly status: 'resolved'; readonly url: string | null };

let cached: PhotoState | null = null;

async function fetchPhotoBlobUrl(): Promise<string | null> {
  const token = await acquireGraphAccessTokenSilent(GRAPH_USER_READ_SCOPE);
  if (token === null) return null;
  let response: Response;
  try {
    response = await fetch(GRAPH_PHOTO_ENDPOINT, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch {
    return null;
  }
  if (!response.ok) {
    return null;
  }
  try {
    const blob = await response.blob();
    if (blob.size === 0) return null;
    return URL.createObjectURL(blob);
  } catch {
    return null;
  }
}

export function fetchCurrentUserPhotoUrl(): Promise<string | null> {
  if (cached !== null) {
    return cached.status === 'resolved'
      ? Promise.resolve(cached.url)
      : cached.promise;
  }
  const promise = fetchPhotoBlobUrl().then((url) => {
    cached = { status: 'resolved', url };
    return url;
  });
  cached = { status: 'pending', promise };
  return promise;
}

export function resetUserPhotoCacheForTesting(): void {
  if (cached !== null && cached.status === 'resolved' && cached.url !== null) {
    URL.revokeObjectURL(cached.url);
  }
  cached = null;
}
